export default {
  setQuestions(state, payload) {
    state.questions = payload;
  },
  setProducts(state, payload) {
    state.sku = payload;
  }
}